import React, { forwardRef, useContext } from 'react';
import { mergeProps } from '@react-aria/utils';
import { Typography } from '../typography';
import { ListItemContext } from './Item';
const VariantBySize = {
    l: 'caption1',
    m: 'caption1',
    s: 'caption2',
    xs: 'caption2',
};
export const Description = forwardRef(function Description({ variant, ...props }, ref) {
    const context = useContext(ListItemContext);
    if (!context) {
        throw new Error('List.Description should be placed inside List.Item component');
    }
    const { descriptionProps, size } = context;
    return React.createElement(Typography, { variant: variant || VariantBySize[size], ...mergeProps(props, descriptionProps), ref: ref });
});
